import React from "react";

import TabPanel from "components/ApiTabPanel/ApiTabPanel";
import CodeCard from "components/shared/CodeCard.js";

export function TabPanelDelete(props) {
  const { name, friendlyName, value } = props;
  return (
    <TabPanel value={value} index={5}>
      <div style={{ width: "66%" }}>
        <h3>Delete</h3>
        <p>Deletes a specific {friendlyName.toLowerCase()} provided by id.</p>
        <CodeCard>DELETE /api/v2/{name.toLowerCase()}/:id</CodeCard>
        <p>Example:</p>
        <CodeCard>DELETE /api/v2/{name.toLowerCase()}/123</CodeCard>
        <p>
          Returns a status object indicating either the delete was successful
          ("status": "ok") or the call failed (error message).
        </p>
      </div>
    </TabPanel>
  );
}
